import React from 'react';
import {SiteFilter, type Department} from '../types/types';
import themeDisplay from '../services/liferay/theme-display';

export type HorizontalNavigationProperties = {
	selectedFilter: SiteFilter;
	onSelected: (filter: SiteFilter) => void;
	departments: Department[];
};

function HorizontalNavigation({departments, selectedFilter, onSelected}: Readonly<HorizontalNavigationProperties>) {
	const [filterCounts, setFilterCounts] = React.useState({
		[SiteFilter.ADULTS]: 0,
		[SiteFilter.KIDS]: 0,
		[SiteFilter.NONMEDICAL]: 0,
	});

	React.useEffect(() => {
		const counts = {
			[SiteFilter.ADULTS]: 0,
			[SiteFilter.KIDS]: 0,
			[SiteFilter.NONMEDICAL]: 0,
		};

		for (const department of departments) {
			for (const filter of department.siteFilter) {
				counts[filter]++;
			}
		}

		setFilterCounts(counts);
	}, [departments]);

	const handleSelect = (filter: SiteFilter) => {
		onSelected(filter);
	};

	return (
		<aside className='uzb-horizontal-navigation '>
			<span>
				<ul>
					<li>
						<button className={selectedFilter === SiteFilter.ADULTS ? 'selected' : ''} onClick={() => {
							handleSelect(SiteFilter.ADULTS);
						}}>{themeDisplay.getLanguageId() === 'nl_NL' ? 'Ziekenhuis volwassenen' : 'Hôpital adultes'} ({filterCounts[SiteFilter.ADULTS]})
						</button>
					</li>
					<li>
						<button className={selectedFilter === SiteFilter.KIDS ? 'selected' : ''} onClick={() => {
							handleSelect(SiteFilter.KIDS);
						}}>{themeDisplay.getLanguageId() === 'nl_NL' ? 'KidZ Health Castle (0-16 jaar)' : 'KidZ Health Castle (0 à 16 ans)'} ({filterCounts[SiteFilter.KIDS]})
						</button>
					</li>
					<li>
						<button className={selectedFilter === SiteFilter.NONMEDICAL ? 'selected' : ''} onClick={() => {
							handleSelect(SiteFilter.NONMEDICAL);
						}}>{themeDisplay.getLanguageId() === 'nl_NL' ? 'Niet-medische diensten' : 'Les services non-médicaux'} ({filterCounts[SiteFilter.NONMEDICAL]})
						</button>
					</li>
				</ul>
			</span>
		</aside>
	);
}

export default HorizontalNavigation;
